import React from 'react';
import classnames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import { SortType } from '@home/enums/common';

import './index.scss';

/**
 * SortByIcon组件props类型
 */
export interface ISortByIconProps extends IBaseProps {
  /**
   * 是否禁用，默认值为false
   */
  disabled?: boolean;
  /**
   * 是否强制展示为无排序，默认值为false
   */
  forceSortTypeNone?: boolean;
  /**
   * 排序方式，升序、降序、无排序
   */
  sortType: SortType;
}

/**
 * 排序图标映射
 */
export const SortTypeIconMap: Record<SortType, string> = {
  /**
   * 无排序图标
   */
  [SortType.None]: 'sort-icon',
  /**
   * 降序图标
   */
  [SortType.Desc]: 'arrow-big-down',
  /**
   * 升序图标
   */
  [SortType.Asc]: 'arrow-big-up',
};

const SortByIcon: React.FC<ISortByIconProps> = (props) => {
  const { style, className, disabled = false, forceSortTypeNone = false, sortType } = props;

  /**
   * 排序图标type
   */
  const svgIconType = (() => {
    if (forceSortTypeNone) return SortTypeIconMap[SortType.None];
    return SortTypeIconMap[sortType] || SortTypeIconMap[SortType.None];
  })();

  return (
    <SvgIcon
      style={style}
      className={classnames('dbi-sort-by-icon', className, {
        /**
         * 高亮class
         */
        'dbi-sort-by-icon--highlight': !!sortType,
        /**
         * 禁用class
         */
        'dbi-sort-by-icon--disabled': disabled,
      })}
      type={svgIconType}
    />
  );
};

export default SortByIcon;
